const hexColorGenerator = function() {
    const red = Math.floor(Math.random() * 256);
    const green = Math.floor(Math.random() * 256);
    const blue = Math.floor(Math.random() * 256);
    return "rgb(" + red  + ", " + green + ", " + blue + ")";
}

export default hexColorGenerator;